import * as ActionTypes from '../actionTypes';

// API
import * as HttpApi from '../Api/index';

export const actionTypes = ActionTypes;

//////////////////
///// GET ////////
//////////////////
export const getAdminOverview = (params) => {
  return (dispatch) => {
    return HttpApi.get('eDATA_ADMIN_OVERVIEW', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getAdminCompany = (params) => {
  return (dispatch) => {
    return HttpApi.get('eDATA_ADMIN_COMPANY', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getAdminProduct = (params) => {
  return (dispatch) => {
    return HttpApi.get('eDATA_ADMIN_PRODUCT', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getCompanyOverview = (params) => {
  return (dispatch) => {
    return HttpApi.get('eDATA_COMPANY_OVERVIEW', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

export const getCompanyProduct = (params) => {
  return (dispatch) => {
    return HttpApi.get('eDATA_COMPANY_PRODUCT', params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  };
};

